const mutations = {
  setIsRoomFavourite(state, value) {
    state.isRoomFavourite = value;
  },
};

export default mutations;
